import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
import StoreOptician from "../../StoreOptician/components/StoreOpticians/StoreOptician/StoreOptician.js";
/* empty css                    */
const StoreOpticians = ({
  className,
  labels,
  opticians,
  fallbackImage,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("store-opticians", className) }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h3" }, labels.title), /* @__PURE__ */ React.createElement("div", { className: "store-opticians__items" }, opticians.map((optician) => /* @__PURE__ */ React.createElement(
    StoreOptician,
    {
      key: optician.name,
      className: "store-opticians__optician",
      name: optician.name,
      details: optician.details,
      imageUrl: optician.imageUrl,
      fallbackImageUrl: fallbackImage
    }
  ))));
};
export {
  StoreOpticians as default
};
//# sourceMappingURL=StoreOpticians.js.map
